import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncAffiliates = async(() =>
  import('../containers/affiliates/Affiliates').then(module => module.default)
);


export default function () {
  return (
    <Switch>
      <Route
        path="/partners/affiliates/:program?"
        component={({
          match: {
            params: {
              urlTitle = 'affiliatesHomeBannerSet'
            }
          }
        }) => (<AsyncAffiliates urlTitle={urlTitle} />)}
      />
      <Redirect
        from="/partners(/*)"
        to="/partners/affiliates/"
        component={({
          match: {
            params: {
              urlTitle = 'affiliatesHomeBannerSet'
            }
          }
        }) => (<AsyncAffiliates urlTitle={urlTitle} />)}
      />
    </Switch>
  );
}
